import styled, { css, keyframes } from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useRouter } from 'next/router';
import { ExpoBannerContainerProps } from '.';
import { useSelector } from 'react-redux';

const SideWidget = ({ handleShow }: ExpoBannerContainerProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { locale } = useRouter();
  return (
    <Container locale={locale} isMobile={isMobile} onClick={handleShow}>
      <div className="text-container">
        <ImageWrapper
          src="assets/images/expo/widget-text.png"
          alt="expo-side-widget"
          fill
        />
      </div>
    </Container>
  );
};

const fadeIn = (translateX: number, isMobile?: boolean) => keyframes`
  from {
    opacity: 0;
    transform: translateX(${translateX}px) scale(${isMobile ? 0.6 : 0.8});
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(${isMobile ? 0.6 : 0.8});
  }
`;

const Container = styled.div<{ locale?: string; isMobile?: boolean }>`
  position: fixed;
  z-index: 1000;
  inset-inline-end: 0;
  bottom: 100px;
  width: 91px;
  height: 293px;
  cursor: pointer;
  background: #112539;
  box-shadow: 0px 0px 9px 0px rgba(194, 194, 194, 0.35);
  border-start-start-radius: 12px;
  border-end-start-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.8);
  transform-origin: ${props => (props.locale == 'en' ? 'right' : 'left')};
  animation: ${props => css`
    ${fadeIn(props.locale === 'ar' ? 5 : -5, props.isMobile)} 0.1s linear
  `};
  .text-container {
    position: relative;
    width: 91px;
    height: 92%;
    transform: ${props => (props.locale == 'ar' ? 'rotate(180deg)' : '')};
  }

  @media screen and (max-width: 768px) {
    bottom: 10px;
    transform: scale(0.6);
    animation: ${props => css`
      ${fadeIn(props.locale === 'ar' ? 5 : -5, props.isMobile)} 0.1s linear
    `};
  }
`;

export default SideWidget;
